import { colors, Tooltip, Typography } from '@ui-components/neo.tax';
import { ReactComponent as WarningTriangle } from '@ui-components/neo.tax/dist/icons/warning-triangle.svg';
import { useMemo } from 'react';

import { getCapitalizationDateString } from './asc-projects-layout.utils';

const EMPTY_FRAGMENT = <></>;

export type AscProjectCapitalizationStartDateCellProps = {
  value: Date | null;
  isCapitalized: boolean;
  missingValueTooltip: string;
};

export const AscProjectCapitalizationStartDateCell = ({
  isCapitalized,
  missingValueTooltip,
  value,
}: AscProjectCapitalizationStartDateCellProps): React.ReactElement => {
  const valueDateString = useMemo(() => {
    if (!isCapitalized) {
      return null;
    }
    return getCapitalizationDateString(value);
  }, [value, isCapitalized]);

  if (!isCapitalized) {
    // show nothing if not capitalized
    return EMPTY_FRAGMENT;
  }

  if (!value) {
    return (
      <Tooltip text={missingValueTooltip}>
        <WarningTriangle width={16} color={colors.lemon[400]} />
      </Tooltip>
    );
  }

  return (
    <Typography color="inherit" textOverflow="truncate" fontSize="inherit">
      {valueDateString}
    </Typography>
  );
};
